import {Injectable} from '@angular/core';

export interface NavigationItem {
  id: string;
  title: string;  
  type: 'item' | 'collapse' | 'group';
  translate?: string;
  icon?: string;
  hidden?: boolean;
  url?: string;
  classes?: string;
  exactMatch?: boolean;
  external?: boolean;
  target?: boolean;
  breadcrumbs?: boolean;
  function?: any;
  badge?: {
    title?: string;
    type?: string;
  };
  children?: Navigation[];
}

export interface Navigation extends NavigationItem {
  children?: NavigationItem[];
}
const NavigationItemsAdmin = [
  {
    id: 'navigation',
    title: 'Navigation',
    type: 'group',
    icon: 'icon-navigation',
    children: [
      {
        id: 'dashboard',
        title: 'Dashboard',
        type: 'collapse',
        icon: 'feather icon-aperture',
        children: [
          {
            id: 'default',
            title: 'Default',
            type: 'item',
            url: '/dashboard/default',
            classes: 'nav-item',
            icon: 'feather icon-plus-square'
          }          
        ]
      }
    ]
  },
  
  {
    id: 'app',
    title: 'APP',
    type: 'group',
    icon: 'icon-other',
    children: [  
      {
        id: 'auto',
        title: 'Autorizaciones',
        type: 'collapse',
        icon: 'feather icon-award',
        children: [
          {
            id: 'activo',
            title: 'Act. Fijo',
            type: 'item',
            url: '/auto/activo',
            classes: 'nav-item',
            icon: 'feather icon-monitor'
          },
          {
            id: 'compra',
            title: 'Compra',
            type: 'item',
            url: '/auto/compra',
            classes: 'nav-item',
            icon: 'feather icon-shopping-cart'
          },
          {
            id: 'conta',
            title: 'Contabilidad',
            type: 'item',
            url: '/auto/conta',
            classes: 'nav-item',
            icon: 'feather icon-book'
          },
          {
            id: 'credito',
            title: 'Credito',
            type: 'item',
            url: '/auto/credito',
            classes: 'nav-item',
            icon: 'feather icon-activity'
          },
          {
            id: 'cxc',
            title: 'Cxc',
            type: 'item',
            url: '/auto/cxc',
            classes: 'nav-item',
            icon: 'feather icon-arrow-right'
          },
          {
            id: 'cxp',
            title: 'Cxp',
            type: 'item',
            url: '/auto/cxp',
            classes: 'nav-item',
            icon: 'feather icon-arrow-left'
          },
          {
            id: 'dinero',
            title: 'Dinero',
            type: 'item',
            url: '/auto/dinero',
            classes: 'nav-item',
            icon: 'feather icon-bell'
          },          
          {
            id: 'gasto',
            title: 'Gasto',
            type: 'item',
            url: '/auto/gasto',
            classes: 'nav-item',
            icon: 'feather icon-credit-card'
          },
          {
            id: 'nomina',
            title: 'Nomina',
            type: 'item',
            url: '/auto/nomina',
            classes: 'nav-item',
            icon: 'feather icon-clock'
          }
        ]
      },
      {
      id: 'feic',
      title: 'FEIC',
      type: 'collapse',
      icon: 'feather icon-octagon',
      children: [
        {
          id: 'cat',
          title: 'Catalogos',
          type: 'item',
          url: '/feic/cat',
          classes: 'nav-item',
          icon: 'feather icon-layers'
        },        
        {
          id: 'ind',
          title: 'Individual',
          type: 'item',
          url: '/feic/individual',
          classes: 'nav-item',
          icon: 'feather icon-user'
        },        
        {
          id: 'jur',
          title: 'Juridico',
          type: 'item',
          url: '/feic/juridico',
          classes: 'nav-item',
          icon: 'feather icon-home'
        },        
        {
          id: 'indiupload',
          title: 'JSON Individual',
          type: 'item',
          url: '/feic/indiupload',
          classes: 'nav-item',
          icon: 'feather icon-cpu'
        },        
        {
          id: 'juriupload',
          title: 'JSON Juridico',
          type: 'item',
          url: '/feic/juriupload',
          classes: 'nav-item',
          icon: 'feather icon-crop'
        }
      ]
      }
    ]
  }
];




@Injectable()
export class NavigationItem {
  get() {
      return NavigationItemsAdmin;    
  };
  getmkMenu(suscripcion: string) {
    if (suscripcion=='ADMIN') {
      return NavigationItemsAdmin;
    } else {
      return NavigationItemsAdmin;
    }
    
  }
}

